export const isValidDate = (date: string | number | Date): boolean => {
  if (typeof date === 'string') {
    const newDate = new Date(date);
    return !isNaN(newDate.getTime());
  }

  if (typeof date === 'number') {
    const newDate = new Date(date);
    return !isNaN(newDate.getTime());
  }

  if (date instanceof Date) {
    return !isNaN(date.getTime());
  }

  return false;
};
